import UISection from 'UIComponents/section/UISection';
import { device } from '../../constants/StyledComponentConstants';
import { OBSIDIAN, OLAF, CALYPSO_MEDIUM } from 'HubStyleTokens/colors';
import { useEffect, useState } from 'react';
import FeaturedSoftwareCoursesHeader from './subcomponents/FeaturedSoftwareCoursesHeader';
import UICardGrid from 'UIComponents/card/UICardGrid';
import AllCoursesButton from '../ContentCards/ReducedContentCard/AllCoursesButton';
//@ts-expect-error Could not find declaration file for module
import useMediaQuery from '../../hooks/useMediaQuery';
import UsageTracker from '../../utils/UsageTracker';
import { safeSmoothScrollTo } from '../../utils/utils';
import { SOFTWARE_TABS, useSoftwareRecommendationsContent, useSoftwareRecommendationsTabs } from '../../features/recommendations';
import UITabs from 'UIComponents/nav/UITabs';
import UITab from 'UIComponents/nav/UITab';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getLang from 'LearningCenterUI/utils/getLang';
import { usePreviouslySelectedTabStore } from '../../features/recommendations/recommendationsStore';
import styled, { academyPageFullWidth } from 'academy-common-lib/utils/Styling';
import ReducedContentCard from '../ContentCards/ReducedContentCard/ReducedContentCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ObsidianSection = styled(UISection).withConfig({
  displayName: "FeaturedSoftwareCoursesSection__ObsidianSection",
  componentId: "sc-1ps5epa-0"
})(["background-color:", ";width:100%;display:flex;justify-content:center;margin-bottom:0 !important;"], OBSIDIAN);
const ObsidianSectionContent = styled.div.withConfig({
  displayName: "FeaturedSoftwareCoursesSection__ObsidianSectionContent",
  componentId: "sc-1ps5epa-1"
})(["", " padding-left:48px;padding-right:48px;padding-top:60px;padding-bottom:60px;color:", ";.certificate-link{color:", ";text-decoration:underline;:hover{color:", ";}}@media screen and ", "{padding-top:24px;padding-bottom:24px;padding-left:14px;padding-right:14px;}"], academyPageFullWidth, OLAF, OLAF, CALYPSO_MEDIUM, device.mobile);
const TabsContainer = styled(UITabs).withConfig({
  displayName: "FeaturedSoftwareCoursesSection__TabsContainer",
  componentId: "sc-1ps5epa-2"
})([".software-tab,.uiButton{color:", ";}.uiButton:hover{color:", ";}"], OLAF, CALYPSO_MEDIUM);
const FeaturedSoftwareCoursesTabs = ({
  onSelectedChange,
  selectedTab
}) => {
  const handleSelectionChange = ({
    target: {
      value
    }
  }) => {
    onSelectedChange(value);
  };
  return /*#__PURE__*/_jsx(TabsContainer, {
    className: "p-top-4 p-bottom-4",
    onSelectedChange: handleSelectionChange,
    selected: selectedTab,
    children: SOFTWARE_TABS.map(tab => /*#__PURE__*/_jsx(UITab, {
      className: "software-tab",
      tabId: tab,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.featuredSoftwareCourses.tabs.${tab}`
      })
    }, `software_tab_${tab}`))
  });
};
const FeaturedSoftwareCoursesSection = () => {
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  const {
    isLoading,
    defaultSelectedTab
  } = useSoftwareRecommendationsTabs();
  const [selectedTab, setSelectedTab] = useState('other');
  const contentToUse = useSoftwareRecommendationsContent(selectedTab, isMobile ? 5 : 6);
  const {
    setPreviouslySelectedTab
  } = usePreviouslySelectedTabStore();
  const handleSelectionChange = tab => {
    UsageTracker.track('interaction', {
      action: 'featured-software-switched-tab',
      tab
    });
    setSelectedTab(tab);
    setPreviouslySelectedTab(tab);
  };
  useEffect(() => {
    setSelectedTab(defaultSelectedTab);
  }, [defaultSelectedTab]);
  const showTabs = !isLoading && getLang() === 'en';
  return /*#__PURE__*/_jsx(ObsidianSection, {
    "data-loading": isLoading,
    children: /*#__PURE__*/_jsxs(ObsidianSectionContent, {
      children: [/*#__PURE__*/_jsx(FeaturedSoftwareCoursesHeader, {
        isLoadingData: isLoading,
        selectedTab: selectedTab
      }), showTabs && /*#__PURE__*/_jsx(FeaturedSoftwareCoursesTabs, {
        onSelectedChange: handleSelectionChange,
        selectedTab: selectedTab
      }), /*#__PURE__*/_jsx(UICardGrid, {
        className: "m-top-6",
        gutterSize: isMobile ? 12 : 24,
        style: {
          gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, max(350px, 100%/4)), 1fr))'
        },
        children: contentToUse.map(({
          type,
          id,
          to
        }, index) => type === 'all' ? /*#__PURE__*/_jsx(AllCoursesButton, {
          "data-test-id": "software-section-card",
          isLoading: isLoading,
          onClick: () => {
            UsageTracker.track('interaction', {
              action: 'featured-software-view-all-clicked',
              hub: selectedTab
            });
            setTimeout(() => {
              safeSmoothScrollTo(window, 0, 0);
            }, 100);
          },
          tab: selectedTab,
          to: to,
          use: "on-dark"
        }, 'all') : /*#__PURE__*/_jsx(ReducedContentCard, {
          appearsIn: "featured-software",
          contentId: Number(id),
          contentType: type,
          "data-test-id": "software-section-card",
          onClick: () => {
            UsageTracker.track('interaction', {
              action: 'featured-software-content-card-click',
              contentId: id,
              contentType: type
            });
          },
          position: index + 1,
          use: "on-dark"
        }, id))
      })]
    })
  });
};
export default FeaturedSoftwareCoursesSection;